import React, { ReactNode } from 'react';

interface IFilterHeaderProps {
	children: ReactNode;
}

const FilterHeader = ({ children }: IFilterHeaderProps) => {
	return (
		<div className="container">
			<div className="row">
				<div className="col-12">
					<div className="fw-bold fs-6 pt-5">{children}</div>
				</div>
			</div>
		</div>
	);
};

export default FilterHeader;
